<div class="tabs-container">
  <div class="tabs">
    <button class="tab" *ngFor="let tab of tabList" (click)="selectTab(tab.value)" [class.selected]="isTabSelected(tab.value)">{{tab.label}}</button>
    <ng-content></ng-content>
  </div>
</div>
